var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8599 15.1667H4.13992C2.31325 15.1667 0.833252 13.68 0.833252 11.8534V6.91336C0.833252 6.00669 1.39325 4.86669 2.11325 4.30669L5.70659 1.50669C6.78659 0.66669 8.51325 0.62669 9.63325 1.41336L13.7533 4.30002C14.5466 4.85336 15.1666 6.04002 15.1666 7.00669V11.86C15.1666 13.68 13.6866 15.1667 11.8599 15.1667ZM6.31992 2.29336L2.72659 5.09336C2.25325 5.46669 1.83325 6.31336 1.83325 6.91336V11.8534C1.83325 13.1267 2.86659 14.1667 4.13992 14.1667H11.8599C13.1333 14.1667 14.1666 13.1334 14.1666 11.86V7.00669C14.1666 6.36669 13.7066 5.48002 13.1799 5.12002L9.05992 2.23336C8.29992 1.70002 7.04659 1.72669 6.31992 2.29336Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12.5C7.72667 12.5 7.5 12.2733 7.5 12V10C7.5 9.72667 7.72667 9.5 8 9.5C8.27333 9.5 8.5 9.72667 8.5 10V12C8.5 12.2733 8.27333 12.5 8 12.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome2);
export default __webpack_public_path__ + "static/media/home-2.edcc59ba505cc2ca9f0066c4bb24a749.svg";
export { ForwardRef as ReactComponent };